/* The message inventory — every class the sending layer knows (Bible §50,
   §33, §28.1 · TOV §26 · locked matrix at WF-11). Four customer classes with
   separate rules enforced at the sending layer, plus account and merchant
   mail. copyStatus 'verbatim' = the copy is drawn in a wireframe frame and
   reproduced exactly; 'draft' = composed from spec facts, flagged for the
   Phase 3 FR proofread before any real send. */
import type { EmailTemplate } from './render'

export const TEMPLATES: EmailTemplate[] = [
  /* ---------- EM-04 · the gift e-mail — the one Ink header ---------- */
  {
    id: 'cadeau',
    name: 'Votre cadeau',
    classe: 'transactionnel', classeLabel: 'Transactionnel — toujours envoyé, zéro promotion',
    subject: 'Votre cadeau chez Valessio',
    preheader: 'Soin profond offert — valable jusqu’au 27 octobre.',
    headline: 'Votre cadeau chez Valessio',
    body: 'Bonjour Léa, Votre cadeau est prêt : <b>Soin profond offert</b>. Valable chez Valessio — Paris 9 jusqu’au 27 octobre. Retrouvez-le à tout moment dans Mes cadeaux.',
    gift: { prize: 'Soin profond offert', code: 'PHVW-XP9V', location: 'Valessio — Paris 9', expiry: '27 octobre 2026' },
    cta: { label: 'Voir mon cadeau', url: '#' },
    from: 'Valessio <hello@mail.buildmyreviews.app> · répondre à contact@valessio…',
    sendRule: 'À l’émission du cadeau (CJ-02) · doit arriver < 10 s dans ≥ 98 % des envois (mesuré, email_log) · renvoi idempotent — jamais un second cadeau.',
    copyStatus: 'verbatim', frameRef: 'EM-04 · TOV §26.1',
  },

  /* ---------- EM-05 · after the visit — the review invitation ---------- */
  {
    id: 'avis',
    name: 'Comment s’est passée votre visite ?',
    classe: 'avis', classeLabel: 'Invitation à donner un avis — finalité et base légale propres',
    subject: 'Comment s’est passée votre visite chez Valessio ?',
    preheader: 'Votre expérience compte pour l’équipe.',
    headline: 'Comment s’est passée votre visite chez Valessio ?',
    body: 'Votre expérience compte pour l’équipe. Si vous avez une minute, partagez votre avis.',
    cta: { label: 'Partager mon avis', url: '#' },
    from: 'Valessio <hello@mail.buildmyreviews.app>',
    sendRule: 'Envoyé +2 h après la visite · aucune mention du cadeau, aucun avantage lié (Rule 1) · revérification avant envoi : fréquence, consentement, suppression, état campagne, destination — envois supprimés comptés avec motif.',
    copyStatus: 'verbatim', frameRef: 'EM-05 · Bible §33 · TOV §26.2',
  },

  /* ---------- EM-06 · the return reminder ---------- */
  {
    id: 'rappel-retour',
    name: 'Une nouvelle expérience vous attend',
    classe: 'rappel', classeLabel: 'Rappel utile — préférence dédiée, jamais couplé au marketing',
    subject: 'Une nouvelle expérience vous attend chez Valessio',
    preheader: 'Votre prochaine étape est disponible.',
    headline: 'Une nouvelle expérience vous attend chez Valessio',
    body: 'Votre prochaine étape est disponible. Revenez à partir du 28 septembre pour découvrir la suite. En attendant, vos cadeaux actifs sont dans Mes cadeaux.',
    cta: { label: 'Voir mon parcours', url: '#' },
    from: 'Valessio <hello@mail.buildmyreviews.app>',
    sendRule: 'Classe « rappel utile » — désactivable séparément du marketing · décrit un avantage existant (prochaine étape + cadeaux actifs) ou ne part pas · fréquence plafonnée par l’automatisation du parcours (RJ-06).',
    copyStatus: 'verbatim', frameRef: 'EM-06 · Bible §28.1 · TOV §26.3',
  },

  /* ---------- expiration reminder — MG-02's « Rappel d’expiration · 14 jours avant » ---------- */
  {
    id: 'rappel-expiration',
    name: 'Rappel d’expiration',
    classe: 'rappel', classeLabel: 'Rappel utile — préférence dédiée',
    subject: 'Votre cadeau est valable encore 14 jours',
    preheader: 'Soin profond offert — jusqu’au 27 octobre chez Valessio — Paris 9.',
    headline: 'Votre cadeau vous attend encore.',
    body: 'Votre <b>Soin profond offert</b> est valable encore 14 jours — jusqu’au 27 octobre, chez Valessio — Paris 9. Il est dans Mes cadeaux, prêt à être présenté en caisse.',
    cta: { label: 'Voir mon cadeau', url: '#' },
    from: 'Valessio <hello@mail.buildmyreviews.app>',
    sendRule: 'Programmé par le réglage du cadeau (MG-02 : rappel 14 j avant) · décrit un avantage existant · une seule relance par cadeau.',
    copyStatus: 'draft', frameRef: 'classe EM-01 · réglage MG-02 — copy à valider (relecture FR, Phase 3)',
  },

  /* ---------- the sign-in code (customers and merchants share the system) ---------- */
  {
    id: 'code',
    name: 'Votre code',
    classe: 'compte', classeLabel: 'Compte — sécurité, toujours envoyé',
    subject: 'Votre code',
    preheader: 'Valable 10 minutes.',
    headline: 'Votre code',
    body: 'Voici votre code de connexion : <b style="font-family:\'Courier New\',Courier,monospace;font-size:26px;letter-spacing:4px;">482913</b><br><br>Il est valable 10 minutes. 5 essais maximum, puis pause de 5 minutes. Si vous n’êtes pas à l’origine de cette demande, ignorez ce message — rien ne se passera.',
    from: 'Build my reviews <hello@mail.buildmyreviews.app>',
    sendRule: 'À chaque demande de connexion (ON-11/12, MG-06) · débit limité · adresse inconnue = même message neutre (pas d’énumération de comptes) · vérification renforcée : un code frais pour facturation, équipe, export, fermeture.',
    copyStatus: 'draft', frameRef: 'ON-12 (faits verbatim : 10 min, 5 essais, pause 5 min) — phrasé e-mail à valider',
  },

  /* ---------- security notice — the OLD address on an e-mail change (MG-13) ---------- */
  {
    id: 'securite-email',
    name: 'Notification de sécurité — changement d’adresse',
    classe: 'compte', classeLabel: 'Compte — sécurité, toujours envoyé',
    subject: 'Votre adresse e-mail est en cours de changement',
    preheader: 'Si ce n’est pas vous, dites-le-nous tout de suite.',
    headline: 'Votre adresse e-mail change.',
    body: 'Une demande de changement d’adresse vient d’être faite sur votre compte Mes cadeaux. Un code de vérification est parti à la nouvelle adresse. Si c’est bien vous, rien à faire — vos cadeaux et parcours suivent automatiquement. Si ce n’est pas vous, sécurisez votre compte dès maintenant.',
    cta: { label: 'Sécuriser mon compte', url: '#' },
    from: 'Build my reviews <hello@mail.buildmyreviews.app>',
    sendRule: 'À l’ancienne adresse, à chaque demande de changement (MG-13 : « l’ancienne reçoit une notification de sécurité ») · idempotent — jamais un second cadeau, jamais un compte dupliqué.',
    copyStatus: 'draft', frameRef: 'MG-13 — copy à valider (relecture FR, Phase 3)',
  },

  /* ---------- team invitation (BI-09/BI-14) ---------- */
  {
    id: 'invitation-equipe',
    name: 'Invitation équipe',
    classe: 'marchand', classeLabel: 'Marchand — compte & équipe',
    subject: 'Lyam vous invite à rejoindre Valessio sur Build my reviews',
    preheader: 'Rôle : Staff · Valessio — Paris 9.',
    headline: 'Lyam vous invite à rejoindre Valessio.',
    body: 'Vous êtes invité·e comme <b>Staff</b> sur <b>Valessio — Paris 9</b>. Ce rôle peut : valider des cadeaux, voir le minimum client nécessaire. Ne peut pas : campagnes, clients, facturation, autres établissements. L’invitation expire dans 7 jours.',
    cta: { label: 'Accepter l’invitation', url: '#' },
    from: 'Build my reviews <hello@mail.buildmyreviews.app>',
    sendRule: 'À l’envoi d’une invitation (BI-09) · expire · renvoi/révocation depuis Équipe — gestion (BI-14) · la première connexion lie l’identité personnelle.',
    copyStatus: 'draft', frameRef: 'BI-09 (capacités verbatim) — phrasé e-mail à valider',
  },

  /* ---------- marketing example — consentement préalable ---------- */
  {
    id: 'marketing',
    name: 'Offre de rentrée',
    classe: 'marketing', classeLabel: 'Marketing — consentement préalable + désinscription',
    subject: 'Offre de rentrée chez Valessio',
    preheader: 'Une attention pour la rentrée — réservée à nos clients.',
    headline: 'Offre de rentrée',
    body: 'Exemple de gabarit marketing (modèle « Offre de rentrée », statut ◔ en revue dans la bibliothèque). Part uniquement avec un consentement marketing actif pour Valessio ; la désinscription marketing ne coupe jamais les messages liés au cadeau.',
    cta: { label: 'Découvrir', url: '#' },
    from: 'Valessio <hello@mail.buildmyreviews.app>',
    sendRule: 'Consentement préalable par marchand (MG-08) · désinscription en un clic · jamais mélangé aux classes transactionnelle et rappel — la séparation vit dans l’envoi.',
    copyStatus: 'draft', frameRef: 'EM-02 (nom + statut verbatim) — contenu marchand, hors périmètre produit',
  },

  /* ---------- the merchant weekly report (EM-09) ---------- */
  {
    id: 'rapport-hebdo',
    name: 'Rapport hebdomadaire',
    classe: 'marchand', classeLabel: 'Marchand — résumé, préférence dédiée',
    subject: 'Votre semaine chez Valessio',
    preheader: '218 participations · 64 cadeaux utilisés · note Google 4,6 → 4,7.',
    headline: 'Votre semaine chez Valessio.',
    body: '<b>218 participations</b> · <b>64 cadeaux utilisés</b> à la caisse · note Google <b>4,6 → 4,7</b> (contexte, pas d’attribution). Mêmes définitions et filtres que votre tableau de bord — le détail vous attend dans Résultats.',
    cta: { label: 'Ouvrir Résultats', url: '#' },
    from: 'Build my reviews <hello@mail.buildmyreviews.app>',
    sendRule: 'Lundi 08:00 · Europe/Paris · destinataires configurés (EM-09) · reprend les définitions du tableau de bord (§55) — jamais d’autres chiffres.',
    copyStatus: 'draft', frameRef: 'EM-09 (cadence + règle verbatim) — phrasé à valider',
  },
]

/** M1 (04/09) — the gift e-mail names the reward the roue actually drew.
 *  The inventory above renders the demo gift verbatim (EM-04); the real send
 *  builds the same template from the Gift record — prize · code · location ·
 *  expiry — so the prize name always comes from the draw, never from a text
 *  a merchant typed. */
export interface DrawnGift { prize: string; code: string; location: string; expiry: string; firstName?: string }
export const DEMO_GIFT: DrawnGift = { prize: 'Soin profond offert', code: 'PHVW-XP9V', location: 'Valessio — Paris 9', expiry: '27 octobre 2026', firstName: 'Léa' }
export function giftEmail(g: DrawnGift = DEMO_GIFT): EmailTemplate {
  const base = TEMPLATES.find(t => t.id === 'cadeau')!
  const until = g.expiry.replace(/ \d{4}$/, '')
  return {
    ...base,
    preheader: `${g.prize} — valable jusqu’au ${until}.`,
    body: `Bonjour${g.firstName ? ' ' + g.firstName : ''}, Votre cadeau est prêt : <b>${g.prize}</b>. Valable chez ${g.location} jusqu’au ${until}. Retrouvez-le à tout moment dans Mes cadeaux.`,
    gift: { prize: g.prize, code: g.code, location: g.location, expiry: g.expiry },
  }
}
